// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-base-control.softlite-button{
    margin-bottom: 13px; 
    /* Đang ở đây tạo margin bootom vì cách xa nhau quá */
}
.softlite-button:not(.softlite-button__link) label{
    font-weight: 400;
    text-transform: capitalize;
    font-size: 13px;
    width: 50%;
    margin-bottom: 0;
}
.softlite-button__text input{
    width: 60%;
}
.softlite-button__link label{
    font-weight: 400;
    text-transform: capitalize;
    font-size: 13px;
}
.softlite-button__text>div{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.softlite-footer-card-upload{
    padding: 7px !important;
    cursor: pointer;
    justify-content: center !important;
}
.softlite-footer-card-upload:hover{
    color: #185ee0;
}
.softlite-button-remove-icon{
    position: absolute;
    top: 0px;
    right: 0px;
}
.softlite-button-remove-icon:focus{
    outline: none !important;
    box-shadow: none !important;
}
.softlite-button-remove-icon>svg{
    color: #cccccc;
}
.softlite-icon>svg{
    width: 20px;
    height: 20px;
}
.softlite-block-button .softlite-icon{
    display: flex;
    align-items: center;
}`, "",{"version":3,"sources":["webpack://./assets/js/src/block/button/button.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,qDAAqD;AACzD;AACA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,eAAe;IACf,UAAU;IACV,gBAAgB;AACpB;AACA;IACI,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,eAAe;AACnB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,uBAAuB;IACvB,eAAe;IACf,kCAAkC;AACtC;AACA;IACI,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;AACd;AACA;IACI,wBAAwB;IACxB,2BAA2B;AAC/B;AACA;IACI,cAAc;AAClB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,aAAa;IACb,mBAAmB;AACvB","sourcesContent":[".components-base-control.softlite-button{\r\n    margin-bottom: 13px; \r\n    /* Đang ở đây tạo margin bootom vì cách xa nhau quá */\r\n}\r\n.softlite-button:not(.softlite-button__link) label{\r\n    font-weight: 400;\r\n    text-transform: capitalize;\r\n    font-size: 13px;\r\n    width: 50%;\r\n    margin-bottom: 0;\r\n}\r\n.softlite-button__text input{\r\n    width: 60%;\r\n}\r\n.softlite-button__link label{\r\n    font-weight: 400;\r\n    text-transform: capitalize;\r\n    font-size: 13px;\r\n}\r\n.softlite-button__text>div{\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n}\r\n.softlite-footer-card-upload{\r\n    padding: 7px !important;\r\n    cursor: pointer;\r\n    justify-content: center !important;\r\n}\r\n.softlite-footer-card-upload:hover{\r\n    color: #185ee0;\r\n}\r\n.softlite-button-remove-icon{\r\n    position: absolute;\r\n    top: 0px;\r\n    right: 0px;\r\n}\r\n.softlite-button-remove-icon:focus{\r\n    outline: none !important;\r\n    box-shadow: none !important;\r\n}\r\n.softlite-button-remove-icon>svg{\r\n    color: #cccccc;\r\n}\r\n.softlite-icon>svg{\r\n    width: 20px;\r\n    height: 20px;\r\n}\r\n.softlite-block-button .softlite-icon{\r\n    display: flex;\r\n    align-items: center;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
